<template>
  <div class="d-flex flex-column align-center justify-center">
    <v-form @submit.prevent="submit" class="forma">
      <h2 class="header">Επεξεργασία Προφίλ</h2>
      <v-text-field
        color="rgb(0,170,221)"
        label="'Ονομα"
        v-model="firstName"
        :error-messages="firstNameErrors"
      ></v-text-field>
      <v-text-field
        color="rgb(0,170,221)"
        label="Επώνυμο"
        v-model="lastName"
        :error-messages="lastNameErrors"
      ></v-text-field>
      <v-text-field color="rgb(0,170,221)" label="Email" disabled v-model="email"></v-text-field>
      <v-autocomplete
        color="rgb(0,170,221)"
        label="Νομός κατοικίας"
        :items="prefectures"
        item-value="option_key"
        item-text="option_value"
        @change="getMunicipalities"
        v-model="prefectureCode"
        :error-messages="prefectureErrors"
      ></v-autocomplete>
      <v-autocomplete
        color="rgb(0,170,221)"
        label="Δήμος κατοικίας"
        :items="municipalities"
        item-value="option_key"
        item-text="option_value"
        :loading="loadingLocal"
        v-model="municipalityCode"
        :error-messages="municipalityErrors"
      ></v-autocomplete>
      <v-text-field
        prefix="(+30)"
        color="rgb(0,170,221)"
        label="Κινητό"
        v-model="mobile"
        :error-messages="mobileErrors"
      ></v-text-field>
      <v-autocomplete label="Ηλικία" color="rgb(0,170,221)" v-model="age" :items="ages"></v-autocomplete>

      <div class="d-flex align-center justify-center my-5">
        <v-btn
          outlined
          color="rgb(74,74,74)"
          rounded
          depressed
          class="text-capitalize"
          @click="$router.replace('profile')"
        >Ακύρωση</v-btn>
        <v-btn
          type="submit"
          rounded
          depressed
          class="text-capitalize white--text ml-5"
          color="rgb(0,170,221)"
          :loading="$store.state.loading"
        >Αποθήκευση</v-btn>
      </div>
    </v-form>

    

    <v-snackbar v-model="fail" :timeout="3000" color="error">
      Αποτυχημένη επεξεργασία
      <v-icon @click="fail=false" color="white">mdi-close</v-icon>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import {
  required,
  numeric,
  minLength,
  maxLength
} from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],

  created() {
    this.loadingLocal = true;
    axios
      .get(`${process.env.VUE_APP_BASE_URL}/optionsList/greekPrefectures/el`)
      .then(res => {
        this.prefectures = res.data;
        return axios.get(
          `${process.env.VUE_APP_BASE_URL}/optionsList/greekMunicipalitiesOfPrefecture/el/${this.prefectureCode}`
        );
      })
      .then(res => {
        this.municipalities = res.data;
        this.loadingLocal = false;
      })
      .catch(err => {
        console.log(err);
        this.loadingLocal = false;
      });
  },

  data() {
    return {
      success: false,
      fail: false,
      loadingLocal: false,
      prefectures: [],
      municipalities: [],
      firstName: !!this.$store.state.user.userProfile ? this.$store.state.user.userProfile.firstName : '',
      lastName: !!this.$store.state.user.userProfile ? this.$store.state.user.userProfile.lastName : '',
      email: !!this.$store.state.user.userProfile ? this.$store.state.user.userProfile.email : '',
      prefectureCode: !!this.$store.state.user.userProfile ? this.$store.state.user.prefectureCode : '',
      municipalityCode: !!this.$store.state.user.userProfile ? this.$store.state.user.municipalityCode : '',
      age: !!this.$store.state.user.userProfile.age ? this.$store.state.user.userProfile.age.toString() : '',
      mobile: !!this.$store.state.user.userProfile ? this.$store.state.user.userProfile.mobile : '',
      ages: [
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
        "32",
        "33",
        "34",
        "35",
        "36",
        "37",
        "38",
        "39",
        "40",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "47",
        "48",
        "49",
        "50",
        "51",
        "52",
        "53",
        "54",
        "55",
        "56",
        "57",
        "58",
        "59",
        "60",
        "61",
        "62",
        "63",
        "64",
        "65",
        "66",
        "67",
        "67",
        "69",
        "70",
        "71",
        "72",
        "73",
        "74",
        "75",
        "76",
        "77",
        "78",
        "79",
        "80",
        "81",
        "82",
        "83",
        "84",
        "85",
        "86",
        "87",
        "88",
        "89",
        "90",
        "91",
        "92",
        "93",
        "94",
        "95",
        "96",
        "97",
        "98",
        "99"
      ]
    };
  },

  methods: {
    getMunicipalities() {
      this.loadingLocal = true;
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/optionsList/greekMunicipalitiesOfPrefecture/el/${this.prefectureCode}`
        )
        .then(res => {
          console.log("hi", res);
          this.loadingLocal = false;
          this.municipalities = res.data;
        })
        .catch(err => {
          this.loadingLocal = false;
          console.log(err);
        });
    },

    submit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const user = {
          municipalityCode: this.municipalityCode,
          userProfile: {
            age: this.age,
            firstName: this.firstName,
            lastName: this.lastName,
            mobile: this.mobile
          }
        };

        this.$store
          .dispatch("editProfile", user)
          .then(res => {
            this.$router.replace({name: 'profile', params: {success: true}});
          })
          .catch(err => {
            this.fail = true;
            console.log(err);
          });
      }
    }
  },

  validations: {
    firstName: {
      required
    },
    lastName: {
      required
    },
    mobile: {
      minLength: minLength(10),
      maxLength: maxLength(10),
      numeric
    },
    prefectureCode: {
      required
    },
    municipalityCode: {
      required
    }
  },

  computed: {
    firstNameErrors() {
      const errors = [];
      if (!this.$v.firstName.$dirty) return errors;
      if (!this.$v.firstName.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.lastName.$dirty) return errors;
      if (!this.$v.lastName.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
    mobileErrors() {
      const errors = [];
      if (!this.$v.mobile.$dirty) return errors;
      if (!this.$v.mobile.minLength)
        errors.push("Εισάγετε έναν έγκυρο αριθμό τηλεφώνου");
      if (!this.$v.mobile.maxLength)
        errors.push("Εισάγετε έναν έγκυρο αριθμό τηλεφώνου");
      if (!this.$v.mobile.numeric) errors.push("Πρέπει να είναι αριθμός");
      return errors;
    },

    prefectureErrors() {
      const errors = [];
      if (!this.$v.prefectureCode.$dirty) return errors;
      if (!this.$v.prefectureCode.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    municipalityErrors() {
      const errors = [];
      if (!this.$v.municipalityCode.$dirty) return errors;
      if (!this.$v.municipalityCode.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  margin-top: 100px;
  @media only screen and (max-width: 600px) {
    margin-top: 40px;
  }
}

.forma {
  width: 500px;
  @media only screen and (max-width: 600px) {
    width: auto;
  }
}
</style>